
import { Select, MenuItem, FormControl, InputLabel, Checkbox, ListItemText } from '@mui/material';

export default function SimpleSelect({value, renderValue, onChange, label, required, multiple, options, selectedOptions, color, sx}) {
    return (
        <FormControl fullWidth color={color} focused={color=="warning"}>
        <InputLabel required={required} id={label+"-id"}>{label}</InputLabel>              
        <Select            
            value={value}
            renderValue={renderValue}
            onChange={onChange}
            labelId={label+"-id"}
            label={label}
            sx={sx}
            required={required}
            multiple={multiple}
        >
            {options.map(
            (option) => {
                if(selectedOptions) {
                    return (
                        <MenuItem key={option.value} value={option.value}>
                            <Checkbox checked={selectedOptions.includes(option.value)} />
                            <ListItemText primary={option.label} />
                        </MenuItem>
                    )
                } else {
                    return (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)

                }
            })}
        </Select>
        </FormControl>
    );
}
  